import type { CaptionStyle } from "@/lib/caption-styles/content";

import CaptionStyleThumbnail from "./CaptionStyleThumbnail";

const CaptionStylePreview = ({ style }: { style: CaptionStyle }) => {
  const isVideo = style.preview.endsWith(".webm") || style.preview.endsWith(".mp4");

  if (isVideo) {
    return (
      <div className="w-full overflow-hidden rounded-2xl border border-[#EFF2FF] bg-[#101828] shadow-sm">
        <video
          src={style.preview}
          poster={style.thumbnail}
          autoPlay
          muted
          loop
          playsInline
          className="aspect-video w-full object-cover"
        />
      </div>
    );
  }

  return (
    <CaptionStyleThumbnail
      style={style}
      priority
      className="aspect-[16/9] rounded-2xl border border-[#EFF2FF] shadow-sm sm:aspect-[2/1]"
      imageClassName="w-[70%] max-w-[520px]"
    />
  );
};

export default CaptionStylePreview;
